import { cn } from "@devhop/ui";
import type { ReactNode } from "react";

type OrderDetailItemRowProps = {
  name: ReactNode;
  details?: ReactNode;
  quantityLine?: ReactNode;
  total: ReactNode;
  actions?: ReactNode;
  muted?: boolean;
};

export function OrderDetailItemRow({
  name,
  details,
  quantityLine,
  total,
  actions,
  muted = false,
}: OrderDetailItemRowProps) {
  return (
    <div
      className={cn(
        "flex items-start justify-between gap-3 rounded-lg border bg-background/60 p-3",
        muted && "opacity-60",
      )}
    >
      <div className="min-w-0 flex-1 space-y-1">
        <div className="font-medium text-sm leading-snug">{name}</div>
        {details}
        {quantityLine && (
          <div className="text-muted-foreground text-xs">{quantityLine}</div>
        )}
      </div>
      <div className="flex shrink-0 items-start gap-2">
        <div className="font-heading font-semibold text-sm tabular-nums">
          {total}
        </div>
        {actions}
      </div>
    </div>
  );
}

export function OrderDetailItemsList({
  children,
  emptyMessage = "ບໍ່ມີລາຍການ",
  isEmpty,
}: {
  children: ReactNode;
  emptyMessage?: string;
  isEmpty?: boolean;
}) {
  if (isEmpty) {
    return (
      <p className="py-6 text-center text-muted-foreground text-sm">
        {emptyMessage}
      </p>
    );
  }

  return <div className="space-y-2">{children}</div>;
}
